import { string, date } from "@src/libs/yup";

export default string()
	.matches(/^\d{2}\/\d{2}\/\d{4}$/, "Date is incorrect format")
	.required("Please enter a value");
